module.exports = __webpack_public_path__ + "lb.9d7809accd70b816267b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/lb.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/lb.svg
// module chunks = styles